<template>
  <picker-field
    :label="label"
    :value="value"
    :is-focus="isFocus"
    :isNeedInput="isNeedInput"
    title="选择售后编码"
    @onchange="onchange"
    ref="picker"
    @open="onSearch"
  >
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="as_code,as_custname"
        placeholder="输入售后编码、客户名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.as_code }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>
            {{ item.as_custname }}
          </p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList,
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "售后编号",
    },
    value: String,
    isNeedInput: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/sale/afterSale/list",
      defaultCondition: [
        {
          field: "as_classify",
          operation: "=",
          value: "产品维修",
        },
        {
          field: "as_status_code",
          operation: "=",
          value: "AUDITED",
        },
      ],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.as_code);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this;
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    },
  },
};
</script>